<template>
  <div class="pt-5 px-5">
    <transition name="fade">
      <MenssageAlert :messages="messages" />
    </transition>

    <h2 class="mt-4 default-header-weight">{{ $t('auth.userDisabled.header2.welcome1') }}</h2>
    <h2 class="default-header-weight">{{ $t('auth.userDisabled.header2.welcome2') }}</h2>

    <div class="d-flex flex-column justify-content-center align-items-center bg-gray-200 py-5 mt-5">
      <h4 class="mt-4 default-header-weight">{{ $t('auth.userDisabled.header4.recover-account') }}</h4>

      <div class="mt-4 text-gray-600 font-md default-header-weight">{{ $t('auth.userDisabled.text.request-remove') }}</div>
      <div class="mb-3 text-gray-600 font-md default-header-weight">{{ $t('auth.userDisabled.text.want-recover') }}</div>

      <CButton class="btn-primary text-uppercase py-3 px-5 my-3 default-header-weight" @click="recoverAccount">
        {{ $t('auth.userDisabled.button.recover-account') }}
      </CButton>

      <!-- Config de text-decoration apenas nesse link -->
      <CLink class="mx-2 mb-3 text-gray-600" style="text-decoration: underline !important" :to="{ name: 'Login' }">
        {{ $t('auth.userDisabled.link.back-to-login') }}
      </CLink>
    </div>
  </div>
</template>

<script>
import services from '@/services'
import MenssageAlert from '@/components/MenssageAlert'
export default {
  components: {
    MenssageAlert,
  },
  data() {
    return {
      userId: null,
      messages: [],
    }
  },
  methods: {
    recoverAccount() {
      this.messages = []
      services
        .enableUser(this.userId)
        .then((response) => {
          this.messages.push({
            status: 'success',
            text: this.$t('auth.userDisabled.messages.success-enable'),
          })

          let self = this
          setTimeout(() => {
            self.$router.push({ name: 'Login' })
          }, 4000)
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message,
          })
        })
    },
  },
  mounted() {
    if (!this.$route.params.userId) {
      this.$router.push({ name: 'Login' })
      return
    }
    this.userId = this.$route.params.userId
  },
  beforeCreate() {
    this.$store.commit('HIDE_BASE_MENU', 'userDisabled')
    this.$store.commit('HIDE_BASE_USER_CONTROLS')
  },
  beforeDestroy() {
    this.$store.commit('SHOW_BASE_MENU')
    this.$store.commit('SHOW_BASE_USER_CONTROLS')
  },
}
</script>

<style>
.default-header-weight {
  font-weight: 600;
}
</style>
